<div class="voices-top-section">
    <div class="app-l-container">
        <div class="app-l-page__navigation">
            <div class="app-l-page__previous" (click)="goBack()">
                <button
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                    <svg-icon icon="arrowLeft" class="w-100 h-100"></svg-icon>
                </button>
            </div>
            <nav class="app-l-page__breadcrumbs" aria-label="Breadcrumb">
                <ul class="breadcrumbs-list">
                    <li class="breadcrumbs-list-item">
                        <a
                            [routerLink]="['/app/series']"
                            translate
                            aria-current="false">
                            series.title
                        </a>
                    </li>
                    <li
                        class="breadcrumbs-list-item app-l-current-page"
                        aria-current="page">
                        {{ title }}
                    </li>
                </ul>
            </nav>
        </div>
        <div class="app-l-voices-banner">
            <div class="app-l-voices-banner__left">
                <h1 class="app-l-voices-banner__heading" translate>
                    {{ title }}
                </h1>
            </div>
        </div>
    </div>
</div>
<page-loader *ngIf="!isVoiceSeriesloaded || !isVideoSeriesloaded"></page-loader>
<div class="app-l-page-wrap" *ngIf="isVoiceSeriesloaded && isVideoSeriesloaded">
    <div id="page-theory" *ngIf="hasVideoContent">
        <div class="app-l-page-header-block">
            <div class="app-l-page-title-block">
                <h2 id="section-title" class="app-l-page-title" translate>
                    series.seriesTypes.video
                </h2>
            </div>
        </div>

        <div class="app-l-course__list">
            <div
                class="app-l-course__items"
                *ngFor="let item of videoSeriesList">
                <div class="course-card">
                    <div class="card-body">
                        <!-- <div class="check"></div> -->
                        <div class="app-l-course__image">
                            <img
                                class="img-responsive"
                                [defaultImage]="
                                    './assets/img/course_image_default.svg'
                                "
                                [lazyLoad]="item.courseImage" />
                            <div class="app-l-course__cnt">
                                <div class="app-l-course__length">
                                    <span translate
                                        >theory.length
                                        <span class="app-l-length__duration">{{
                                            item.length
                                        }}</span>
                                    </span>
                                    <!-- <span translate>{{'theory.courses.' + item.key + '.length'}}</span> -->
                                </div>
                                <h3
                                    class="app-l-course__title"
                                    aria-live="polite"
                                    tabindex="0"
                                    translate>
                                    {{ item.name }}
                                </h3>
                            </div>

                            <div translate class="app-l-course__video-status">
                                <div
                                    *ngIf="
                                        !item.completed &&
                                        item.courseProgress === 'inprogress'
                                    "
                                    class="app-l-course__badge app-l-course__badge-inprogress">
                                    <svg-icon
                                        icon="timer"
                                        class="app-l-course__badge-icon"
                                        alt="timer"></svg-icon>
                                    <span
                                        class="app-l-course__badge-text"
                                        translate
                                        >theory.inProgress</span
                                    >
                                </div>
                                <div
                                    *ngIf="item.completed"
                                    class="app-l-course__badge app-l-course__badge-completed">
                                    <svg-icon
                                        icon="tick-circle"
                                        class="app-l-course__badge-icon"
                                        alt="tick-circle"></svg-icon>
                                    <span
                                        class="app-l-course__badge-text"
                                        translate
                                        >theory.completed</span
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="card-content">
                            <!-- <span class="status-badge" translate>{{item.completed ? 'Completed':
                            'In-Progress'}}</span> -->

                            <p [innerHtml]="item.description"></p>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button
                            tabindex="0"
                            class="app-c-btn app-c-btn--secondary app-c-btn--curve"
                            aria-label="start video button"
                            translate
                            (click)="goToCourse(item)"
                            (keypress)="goToCourse(item)">
                            {{
                                item.completed
                                    ? 'theory.restart'
                                    : 'theory.start'
                            }}
                        </button>
                        <span class="app-l-course-video-count"
                            >{{ item.videoCount }}
                            <span translate>theory.videos</span></span
                        >
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="videoSeriesList.length === 0">
            <div class="empty-card">
                <div class="app-dm-positive-cards" translate>series.noData</div>
            </div>
        </ng-container>
    </div>
    <div
        id="page-audios"
        *ngIf="this.enableVoiceSeries && (hasStoryContent || hasBqContent)">
        <div class="app-l-page-header-block">
            <div class="app-l-page-title-block">
                <h2 id="section-title" class="app-l-page-title" translate>
                    series.seriesTypes.audio
                </h2>
            </div>
        </div>
        <div class="series-type-section">
            <div class="series-type-list">
                <ng-container *ngFor="let voice of voiceSeriesList">
                    <div
                        class="series-type-card type-allen"
                        *ngIf="voice.seriesType == 'stories'">
                        <div
                            class="cover-image-section default-bg"
                            (click)="goToVoiceStory('stories', voice)">
                            <img
                                [defaultImage]="
                                    '../../../assets/img/series/voice-stories-bg.svg'
                                "
                                [lazyLoad]="voice.imageUrl" />

                            <div class="card-content" translate>
                                {{ voice ? voice['title_' + lang] : '' }}
                                <span>{{
                                    voice ? voice['author_' + lang] : ''
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="app-l-burning-questions-holder"
                        *ngIf="voice.seriesType == 'burningQuestion'">
                        <div
                            class="app-l-burning-questions-holder_items"
                            (click)="goToVoiceStory('burningQuestions', voice)">
                            <div class="app-l_container">
                                <div class="app-l-content">
                                    <span>{{
                                        voice ? voice['title_' + lang] : ''
                                    }}</span>
                                    <img
                                        class="bg-img"
                                        [defaultImage]="
                                            '../../../assets/img/series/voice-bq-default.svg'
                                        "
                                        [lazyLoad]="voice.imageUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <ng-container *ngIf="voiceSeriesList.length === 0">
            <div class="empty-card">
                <div class="app-dm-positive-cards" translate>series.noData</div>
            </div>
        </ng-container>
    </div>
    <div
        id="page-audios"
        *ngIf="this.enableReadsSeries && hasReadsContent">
        <div class="app-l-page-header-block">
            <div class="app-l-page-title-block">
                <h2 id="section-title" class="app-l-page-title" translate>
                    series.seriesTypes.reads
                </h2>
            </div>
        </div>
        <div class="series-type-section">
            <div class="series-type-list">
                <ng-container *ngFor="let read of readsList">
                    <div
                        class="series-type-card type-allen"
                        >
                        <div
                            class="cover-image-section default-bg"
                            (click)="goToRead(read)">
                            <img
                                [defaultImage]="
                                    '../../../assets/img/series/reads.svg'
                                "
                                [lazyLoad]="read.thumbnailUrl" />

                            <div class="card-content" translate>
                                {{ read ? read['title' + lang] : '' }}
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <ng-container *ngIf="readsList.length === 0">
            <div class="empty-card">
                <div class="app-dm-positive-cards" translate>series.noData</div>
            </div>
        </ng-container>
    </div>
    <div
        id="page-daily-content"
        *ngIf="this.enableDailySeries && hasDailyContent">
        <div class="app-l-page-header-block">
            <div class="app-l-page-title-block">
                <h2 id="section-title" class="app-l-page-title" translate>
                    series.pastDailyContent
                </h2>
            </div>
        </div>
        <div class="series-type-past">
            <ng-container *ngFor="let content of pastDailyContents">
                <div
                    class="series-type-past_card"
                    [ngStyle]="{ background: content.lightColor }">
                    <div
                        class="series-type-past_card_content"
                        [ngStyle]="{ background: content.bgColor }">
                        <span class="quote-mark" aria-hidden="true"
                            ><img
                                src="./assets/img/icons-svg/quote-mark-top.svg"
                                alt=""
                        /></span>
                        <p [ngStyle]="{ color: content.textColor }">
                            {{ content['text_' + lang] }}
                        </p>
                        <span class="quote-mark" aria-hidden="true"
                            ><img
                                src="./assets/img/icons-svg/quote-mark-right.svg"
                                alt=""
                        /></span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
